/**
 * Zentrales Analytics-Modul (Aug 2026 — PostHog ENTFERNT).
 *
 * First-Party statt Drittanbieter: trackEvent() sendet cookielos per sendBeacon
 * an /api/t (anonym: keine IP-Speicherung, keine IDs, keine Gerätespeicherung
 * → keine Consent-Pflicht nach § 25 TDDDG / § 165 TKG). Eingeloggtes
 * Produktverhalten wird zusätzlich SERVERSEITIG getrackt (Backend-Middleware,
 * Opt-out via users.analytics_opt_out). Auswertung: Admin → Nutzung.
 *
 * Die bisherigen PostHog-Funktionssignaturen bleiben als No-ops erhalten,
 * damit bestehende Aufrufer (CookieBanner, AuthContext, …) nicht brechen.
 */
import { isLexMode } from '@/utils/lexDomain';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function currentProduct() {
  return isLexMode() ? 'lex.ivoliq' : 'ivoliq';
}

function utmParams() {
  try {
    const p = new URLSearchParams(window.location.search);
    return { utm_source: p.get('utm_source') || '', utm_campaign: p.get('utm_campaign') || '' };
  } catch (_) { return {}; }
}

function beacon(event, props = {}) {
  try {
    const body = JSON.stringify({
      event,
      props: {
        page: window.location.pathname,
        referrer: document.referrer || '',
        product: currentProduct(),
        ...utmParams(),
        ...props,
      },
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/t`, new Blob([body], { type: 'application/json' }));
    } else {
      fetch(`${API}/t`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true });
    }
  } catch (_) { /* Analytics darf nie die App stören */ }
}

/** Anonymer Seitenaufruf (Landing/Marketing) — cookielos, consent-frei. */
export function trackPageview() {
  beacon('pageview');
}

/** Frontend-Event — läuft first-party in die eigene Auswertung (Admin → Nutzung). */
export function trackEvent(name, props = {}) {
  if (typeof window !== 'undefined' && window.gtag) window.gtag('event', name, props);
  beacon(name, props);
  // Eingeloggt: zusätzlich pseudonymes Produkt-Event (401 für Gäste ist ok & still)
  try {
    fetch(`${API}/track`, {
      method: 'POST', credentials: 'include', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event: name, props }),
    }).catch(() => {});
  } catch (_) { /* nie die App stören */ }
}

// ── Kompatibilitäts-No-ops (PostHog entfernt) ──
export function initPostHog() {}
export function grantAnalyticsConsent() {}
export function revokeAnalyticsConsent() {}
export function identifyUser() {}
export function resetAnalyticsUser() {}
